// extracted by mini-css-extract-plugin
export default {"background":"Registration_background__7WGrL","logo":"Registration_logo__X9ZNG","overlay":"Registration_overlay__qECLY","container":"Registration_container__Djz0x"};